import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from '../../../actions/index.types'
import { toast } from 'react-toastify';
import * as req from '../../../../axios/request/SocietyPortal/AccountsClosingReqs/AccountsClosingReqs'


function* getGlAccountsClosing(action) {
    try {
        const result = yield call(req.getGlAccountsClosingReq, action);
        if (result.success === true) {
            yield put({ type: types.GET_GL_ACCOUNTS_CLOSING_SUCCESS, payload: result.data });
        } else {
            yield put({ type: types.GET_GL_ACCOUNTS_CLOSING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to fetch GL accounts closing balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.GET_GL_ACCOUNTS_CLOSING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}

function* createAccountsClosing(action) {
    try {
        const result = yield call(req.createAccountsClosingReq, action);
        if (result.success === true) {
            toast.success(result.message || "Closing balance saved successfully");
            yield put({ type: types.CREATE_ACCOUNTS_CLOSING_SUCCESS, payload: result.data });
            action?.data?.onSuccess?.();
        } else {
            yield put({ type: types.CREATE_ACCOUNTS_CLOSING_FAILURE, message: result?.message });
            toast.error(result?.message || "Failed to create closing balance");
        }
    } catch (e) {
        console.log(e)
        yield put({ type: types.CREATE_ACCOUNTS_CLOSING_FAILURE, message: e?.message });
        toast.error(e?.message || "Something went wrong");
    }
}


export default function* AccountsClosingSaga() {
    yield takeLatest(types.GET_GL_ACCOUNTS_CLOSING, getGlAccountsClosing);
    yield takeLatest(types.CREATE_ACCOUNTS_CLOSING, createAccountsClosing);
}
